import axios from "axios";

const baseUrl =   process.env.REACT_APP_GITO_API_URL + "/charging-points/ChargingPoint";
//const baseUrl = "https://localhost:7241/ChargingPoint";

const mappingBaseUrl =
  process.env.REACT_APP_GITO_API_URL + "/charging-points/chargingPointThirdPartySystemMapping";
  const configurationBaseUrl =
    process.env.REACT_APP_GITO_API_URL + "/charging-points/Configuration";
const diagnosticsbaseUrl = process.env.REACT_APP_GITO_API_URL + "/charging-points/diagnostics";


// Function to get all charging points
export async function getAllChargingPoints(apiAccessToken) {
  try {
    const response = await axios.get(`${baseUrl}/get-all-charging-points`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiAccessToken}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch all charging points"
    );
  }
}


// Function to get a specific charging point by chargingPointPublicId
export async function getChargingPoint(chargingPointPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${baseUrl}/get-charging-point/${chargingPointPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging point"
    );
  }
}

// Function to create a new charging point
export async function createChargingPoint(chargingPointData, apiAccessToken) {
  try {
    const response = await axios.post(
      `${baseUrl}/create-charging-point`,
      chargingPointData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to create charging point"
    );
  }
}

// Function to update an existing charging point
export async function updateChargingPoint(chargingPointData, apiAccessToken) {
  try {
    console.log("Charging point data being sent to API:", chargingPointData);

    const response = await axios.put(
      `${baseUrl}/update-charging-point`,
      chargingPointData,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to update charging point"
    );
  }
}

// Function to delete a charging point by chargingPointPublicId
export async function deleteChargingPoint(
  chargingPointPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.delete(
      `${baseUrl}/delete-charging-point/${chargingPointPublicId}`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to delete charging point"
    );
  }
}

export async function getChargingPointConfigurations(
  chargingPointPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GITO_API_URL}/charging-points/Configuration/get-point-configurations/${chargingPointPublicId}`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to get charging point configurations"
    );
  }
}


// Function to get third-party system mapping for a charging point
export async function getChargingPointThirdPartySystemMapping(
  chargingPointPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
      `${mappingBaseUrl}/get-charging-point-third-party-system-mapping-for-charging-point/${chargingPointPublicId}`,
      {
        headers: {
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to fetch third-party system mapping"
    );
  }
}

// Function to add third-party system mapping for a charging point
export async function addChargingPointThirdPartySystemMapping(
  mappingData,
  apiAccessToken
) {
  try {
    const response = await axios.post(
      `${mappingBaseUrl}/add-charging-point-third-party-system-mapping`,
      mappingData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to add third-party system mapping"
    );
  }
}

// Function to update third-party system mapping for a charging point
export async function updateChargingPointThirdPartySystemMapping(
  mappingData,
  apiAccessToken
) {
  try {
    const response = await axios.put(
      `${mappingBaseUrl}/update-charging-point-third-party-system-mapping`,
      mappingData,
      {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to update third-party system mapping"
    );
  }
}

// Function to delete third-party system mapping for a charging point
export async function deleteChargingPointThirdPartySystemMapping(
  chargingPointPublicId,
  thirdPartySystemPublicId,
  thirdPartySystemExternalId,
  apiAccessToken
) {
  try {
    const response = await axios.delete(
      `${mappingBaseUrl}/delete-charging-point-third-party-system-mapping/${chargingPointPublicId}/${thirdPartySystemPublicId}/${thirdPartySystemExternalId}`,
      {
        headers: {
          "Authorization": `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to delete third-party system mapping"
    );
  }
}

export async function getChargingPointGlobalConfigurations(
  apiAccessToken
) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_GITO_API_URL}/charging-points/Configuration/get-global-configuration`,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to get global charging point configurations"
    );
  }
}
export async function patchChargingPointGlobalConfigurations(configurations,
  apiAccessToken
) {

  /*
  {
  "values": [
    {
      "configurationName": "string",
      "gitoDefaultValue": "string"
    }
  ]
}
  */

  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_GITO_API_URL}/charging-points/Configuration/update-global-configuration`,
      configurations,
      {
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail ||
        "Failed to patch global charging point configurations"
    );
  }
}

export async function getGlobalChargingPointDefaultConfiguration(chargingPointPublicId, apiAccessToken) {
  try {
    const response = await axios.get(
      `${configurationBaseUrl}/get-global-defaults/${chargingPointPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging point"
    );
  }
}

export async function getChargingPointDiagnostics(
  chargingPointPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
        `${diagnosticsbaseUrl}/get-diagnostics/${chargingPointPublicId}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to fetch charging point diagnostics"
    );
  }
}

export async function downloadChargingPointDiagnostics(
  diagnosticsPublicId,
  apiAccessToken
) {
  try {
    const response = await axios.get(
        `${diagnosticsbaseUrl}/download/${diagnosticsPublicId}`,
      {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${apiAccessToken}`,
        },
      }
    );
    return {
      blob: response.data,
      contentDisposition: response.headers["content-disposition"],
      contentType: response.headers["content-type"],
    };
  } catch (error) {
    throw new Error(
      error.response?.data?.detail || "Failed to download diagnostics file"
    );
  }
}


